module.exports = __webpack_public_path__ + "img/jxfw.f82d6585.png";